<div class="error-container">
  <h1 class="error-code" i18n="@@pages.notFound.title.main">404</h1>
  <h2 class="error-title" i18n="@@pages.notFound.title.secondary">ページが見つかりません</h2>
  <p class="error-message" i18n="@@pages.notFound.message.pageNotFound">
    お探しのページは見つかりませんでした。<br>
    URLが正しいかご確認ください。
  </p>

  <div class="actions">
    @if (hasSections && firstSection) {
      <a [routerLink]="['/home', firstSection.id]" class="button button--primary" i18n="@@pages.notFound.button.backToHome">
        ホームに戻る
      </a>
    }
    <a routerLink="/" class="button" i18n="@@pages.notFound.button.backToLogin">
      ログイン画面に戻る
    </a>
  </div>
</div>
